/*
 * @Author: etong
 * @Date: 2021-06-10 15:21:52
 * @LastEditTime: 2021-06-10 15:25:14
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\store\getters\vmRouteQuene\index.js
 * Think first, Program later
 */
const vmRouteQuene = {
  _vmRouteQuene: state => state.vmRouteQuene._vmRouteQuene, // 审批流数据
}

export default vmRouteQuene
